import axios from 'axios'
import host from './host'
import store from '@/store'
import router from '@/router'
import md5 from 'js-md5'
import api from './api'
import os from '@utils/os'
import vm from '@/main'
import Type from '@utils/type'
import { doEncrypt } from '@utils/crypto'

const encryptKey = 'encryptData'

const service = axios.create({
  baseURL: '',
  timeout: 10000
})

service.interceptors.request.use(
  config => {
    const { method, gatConfig } = config
    const headers = {
      ...config.headers,
      // 'TOKEN': localStorage.getItem('token'),
      // 'REFRSH-TOKEN': localStorage.getItem('refresh_token'),
      // 'ACCPET-ENCODING': localStorage.getItem('sys_token'),
      accept: 'application/json, text/plain, */*'
    }

    if (localStorage.getItem('token')) {
      headers.Authorization = 'Bearer ' + localStorage.getItem('token')
    }
    if (gatConfig.encrypt) headers['X-Encrypt'] = encryptKey

    // if (method === 'post' || method === 'put') {
    // const timestamp = new Date() * 1
    let platform = 6
    // const sign = md5('platform=' + platform + '&timestamp=' + timestamp)
    if (store.getters.isInApp && !os.isPC()) {
      if (os.isIOS()) {
        platform = 6
      } else if (os.isAndroid()) {
        platform = 6
      }
    }

    const userID = localStorage.getItem('userID')

    let data = {
      platform,
      // sign,
      // timestamp,
      userID: userID,
      ...(method === 'get' ? config.params : config.data)
    }

    // if (gatConfig.encrypt) {
    //   data = {
    //     [encryptKey]: doEncrypt(data)
    //   }
    // }

    config = {
      ...config,
      headers,
      [method === 'get' ? 'params' : 'data']: data
    }
    // }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    const { gatConfig } = response.config

    if (res.code == 0) {
      return res
    } else {
      if (res.code == 401) {
        store.dispatch('user/logout')
        router.push('/login')
        if (gatConfig.showTips) vant.Toast.fail(vm.$ct('您的登录状态已失效，请重新登录！'))
      } else {
        if (res.codeDesc && gatConfig.showTips) vant.Toast.fail(vm.$ct(res.codeDesc))
      }
      return Promise.reject(res)
    }
  },
  error => {
    console.log('err' + error) // for debug
    vant.Toast.fail(error.msg)
    return Promise.reject(error)
  }
)

// config option keys
// showTips
// encrypt
function handleConfig(config) {
  return Type.isObject(config)
    ? {
        showTips: true,
        ...config
      }
    : {
        showTips: config
      }
}

class Request {
  static post(url, params, showTips = true) {
    url = url.indexOf('https') != -1 ? url : host.javaDoMain + url
    return service({
      url,
      method: 'post',
      data: params,
      gatConfig: handleConfig(showTips)
    })
  }

  static selinfoPost(params, showTips = true) {
    let url = '/hospro/hospital/selInfo?'
    for (const key in params) {
      if (key == 'params') {
        url = url + key + '=' + JSON.stringify(params[key]) + '&'
      } else {
        url = url + key + '=' + params[key] + '&'
      }
    }
    return this.post(url, params, showTips)
  }

  static get(url, params, showTips = true) {
    url = url.indexOf('https') != -1 ? url : host.javaDoMain + url
    return service({
      url,
      method: 'get',
      params,
      gatConfig: handleConfig(showTips)
    })
  }
  static put(url, params, showTips = true) {
    url = url.indexOf('https') != -1 ? url : host.javaDoMain + url
    return service({
      url,
      method: 'put',
      data: params,
      gatConfig: handleConfig(showTips)
    })
  }
  static delete(url, params, showTips = true) {
    url = url.indexOf('https') != -1 ? url : host.javaDoMain + url
    return service({
      url,
      method: 'delete',
      data: params,
      gatConfig: handleConfig(showTips)
    })
  }
}

export default Request
